const browserSupportsAllFeatures = () => 'IntersectionObserver' in window;

if (browserSupportsAllFeatures()) {
  import('./client');
} else {
  import('intersection-observer').then(() => {
    import('./client');
  });
}
